import { AnalyticsEvent } from "./analyticsEvent"
class FilterInteractionsEvent extends AnalyticsEvent {
    constructor(
        public filterCategory: string,
        public filterName: string) {
        super();
    }
}
export { FilterInteractionsEvent }